import { render } from "./MHeader.vue?vue&type=template&id=0d1196aa"
import script from "./MHeader.vue?vue&type=script&lang=js"
export * from "./MHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__